// extracted by mini-css-extract-plugin
export var cardHeader = "_ev-0";
export var reorderHandle = "_ev-3";
export var titleArea = "_ev-1";
export var titleAreaWithHandle = "_ev-2";